import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantTransactionCategories } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useTransactionCategories = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.TRANSACTION_CATEGORIES, orgSlug, restaurantId], () =>
    tenantTransactionCategories({ orgSlug, restaurantId })
  );
};
